import images from "./images";

const schedule = [
    {
        id: 1,
        image: images.session1,
        title: "AI in Autonomous Vehicles",
        content: "Discover how AI is driving the development of autonomous vehicles and the challenges ahead.",
        details: {
            category: "Technology, AI, Autonomous Vehicles",
            date: "1 January 2025",
            time: "10:00 AM - 1:00 PM",
            venue: "Main Auditorium",
            organizer: "Autonomous Vehicle Innovations Forum",
            number: "+123-456-7890",
            email: "info@aiconference.com",
            entryFee: "$100 per attendee"
        },
        paragraphs: [
            "Explore how AI is transforming the future of autonomous vehicles, from self-learning algorithms to real-time decision-making.",
            "Gain insights from top industry experts on the challenges, innovations, and breakthroughs in AI-driven transportation technology."
        ],
        gallery: [
            images.session1Gallery1,
            images.session1Gallery2
        ],
        agenda: [
            "Welcome and Introduction",
            "AI Innovations in Self-Driving Technology",
            "Real-Time Decision-Making with AI",
            "Challenges and Ethical Considerations",
            "Future of AI in Autonomous Mobility"
        ],
        learningOutcomes: [
            "Understand AI-driven decision-making in autonomous vehicles.",
            "Discover real-world applications of AI in self-driving technology.",
            "Explore ethical and regulatory challenges in AI transportation.",
            "Learn how sensor fusion enhances autonomous vehicle safety.",
            "Gain insights into future AI trends in smart mobility."
        ],
        speakerIds: [1, 6],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 2,
        image: images.session2,
        title: "The Future of AI in Healthcare",
        content: "Explore how AI is revolutionizing healthcare with real-world applications and future trends.",
        details: {
            category: "Technology, AI, Healthcare",
            date: "1 January 2025",
            time: "1:30 PM - 3:30 PM",
            venue: "Hall No 2",
            organizer: "AI in Healthcare Summit",
            number: "+123-456-7891",
            email: "info@aihealthcare.com",
            entryFee: "$120 per attendee"
        },
        paragraphs: [
            "Discover the transformative impact of AI in healthcare, from diagnostics to treatment planning and patient care.",
            "Join leading experts as they discuss AI-driven advancements in medical imaging, predictive analytics, and personalized medicine."
        ],
        gallery: [
            images.session2Gallery1,
            images.session2Gallery2
        ],
        agenda: [
            "Opening Remarks",
            "AI-Powered Diagnostics and Imaging",
            "Machine Learning in Drug Discovery",
            "Ethical and Privacy Concerns in AI Healthcare",
            "Future Trends in AI-Driven Healthcare"
        ],
        learningOutcomes: [
            "Understand AI's role in enhancing medical diagnostics and imaging.",
            "Explore how machine learning is accelerating drug discovery.",
            "Gain insights into ethical and privacy challenges in AI healthcare.",
            "Learn how AI-driven predictive analytics improve patient outcomes.",
            "Discover emerging trends shaping the future of AI in medicine."
        ],
        speakerIds: [2, 8],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.session3,
        title: "Machine Learning and Cybersecurity",
        content: "Understand the role of machine learning in enhancing cybersecurity and combating cyber threats.",
        details: {
            category: "Technology, AI, Cybersecurity",
            date: "1 January 2025",
            time: "4:00 PM - 6:00 PM",
            venue: "Hall No 3",
            organizer: "Cybersecurity AI Forum",
            number: "+123-456-7892",
            email: "info@aicybersecurity.com",
            entryFee: "$110 per attendee"
        },
        paragraphs: [
            "Discover how machine learning is transforming cybersecurity, from threat detection to real-time risk mitigation.",
            "Join cybersecurity experts to explore AI-driven defense strategies, anomaly detection, and the future of cyber protection."
        ],
        gallery: [
            images.session3Gallery1,
            images.session3Gallery2
        ],
        agenda: [
            "Introduction to AI in Cybersecurity",
            "Machine Learning for Threat Detection",
            "AI-Powered Fraud Prevention",
            "Ethical Considerations in AI Security",
            "The Future of AI-Driven Cyber Defense"
        ],
        learningOutcomes: [
            "Understand how AI improves cybersecurity threat detection.",
            "Explore machine learning techniques for identifying cyber threats.",
            "Learn about AI-driven fraud detection and prevention methods.",
            "Gain insights into ethical and legal challenges in AI security.",
            "Discover future trends in AI-based cybersecurity strategies."
        ],
        speakerIds: [1, 3],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.session4,
        title: "The Role of AI in Smart Cities",
        content: "Explore how AI is transforming urban living, from traffic management to smart energy solutions.",
        details: {
            category: "Technology, AI, Smart Cities",
            date: "1 January 2025",
            time: "6:00 PM - 8:00 PM",
            venue: "Innovation Hall",
            organizer: "Smart Cities AI Forum",
            number: "+123-456-7893",
            email: "info@aismartcities.com",
            entryFee: "$120 per attendee"
        },
        paragraphs: [
            "Discover how AI is revolutionizing urban environments, improving infrastructure, and enhancing city-wide efficiency.",
            "Join leading experts to discuss AI-driven traffic management, energy optimization, and the future of intelligent urban planning."
        ],
        gallery: [
            images.session4Gallery1,
            images.session4Gallery2
        ],
        agenda: [
            "Introduction to AI in Smart Cities",
            "AI-Powered Traffic and Transportation Systems",
            "Smart Energy Management with AI",
            "Challenges and Ethical Considerations",
            "Future Trends in AI-Driven Urban Development"
        ],
        learningOutcomes: [
            "Understand AI’s impact on smart city infrastructure.",
            "Learn how AI optimizes traffic and public transportation.",
            "Explore AI-driven energy efficiency and sustainability.",
            "Discover the role of AI in smart governance and security.",
            "Gain insights into the future of AI-powered urban planning."
        ],
        speakerIds: [4, 5],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },

    {
        id: 5,
        image: images.session5,
        title: "AI in Education: Personalized Learning",
        content: "Learn how AI is enabling personalized learning experiences and transforming the education sector.",
        details: {
            category: "Technology, AI, Education",
            date: "2 January 2025",
            time: "10:45 AM - 12:15 PM",
            venue: "Innovation Hall",
            organizer: "EdTech AI Conference",
            number: "+123-456-7894",
            email: "info@aieducation.com",
            entryFee: "$80 per attendee"
        },
        paragraphs: [
            "Explore how AI is revolutionizing education by personalizing learning experiences for students of all levels.",
            "Join experts in AI and education technology to discuss adaptive learning systems, AI-driven tutoring, and the future of personalized education."
        ],
        gallery: [
            images.session5Gallery1,
            images.session5Gallery2
        ],
        agenda: [
            "Introduction to AI in Education",
            "Adaptive Learning Systems and AI",
            "AI-Powered Personalized Tutoring",
            "Ethical and Privacy Concerns in AI Education",
            "Future Trends in AI-Driven Learning"
        ],
        learningOutcomes: [
            "Understand AI's role in personalized learning experiences.",
            "Learn how AI adapts content based on student progress.",
            "Explore AI-powered tutoring and smart assessments.",
            "Discover ethical considerations in AI-driven education.",
            "Gain insights into future trends in AI education."
        ],
        speakerIds: [5, 2],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 6,
        image: images.session6,
        title: "AI in Robotics: Building the Future",
        content: "Explore how AI is advancing robotics and creating new possibilities in automation and beyond.",
        details: {
            category: "Technology, AI, Robotics",
            date: "2 January 2025",
            time: "12:30 PM - 2:00 PM",
            venue: "Tech Lab",
            organizer: "AI Robotics Forum",
            number: "+123-456-7895",
            email: "info@airobotics.com",
            entryFee: "$90 per attendee"
        },
        paragraphs: [
            "Discover how AI is revolutionizing robotics, from autonomous machines to intelligent automation in various industries.",
            "Join industry experts to discuss real-world AI applications in robotics, from healthcare and manufacturing to space exploration and smart assistants."
        ],
        gallery: [
            images.session6Gallery1,
            images.session6Gallery2
        ],
        agenda: [
            "Introduction to AI in Robotics",
            "Machine Learning for Robotics",
            "Autonomous Systems and AI",
            "AI-Powered Robotics in Industry",
            "Future Innovations in AI Robotics"
        ],
        learningOutcomes: [
            "Understand how AI enhances robotic automation.",
            "Learn about AI-driven decision-making in robotics.",
            "Explore real-world applications of AI in robotics.",
            "Discover the role of AI in autonomous robotic systems.",
            "Gain insights into the future of AI-powered robotics."
        ],
        speakerIds: [6, 1],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 7,
        image: images.session7,
        title: "AI and Augmented Reality",
        content: "Discover the intersection of AI and AR and how this combination is enhancing user experiences.",
        details: {
            category: "Technology, AI, Augmented Reality",
            date: "2 January 2025",
            time: "2:15 PM - 3:45 PM",
            venue: "Hall No 2",
            organizer: "AI & AR Innovations Forum",
            number: "+123-456-7896",
            email: "info@ai-arforum.com",
            entryFee: "$95 per attendee"
        },
        paragraphs: [
            "Explore how AI is transforming augmented reality by making interactions more intuitive, immersive, and intelligent.",
            "Join leading experts to learn about AI-powered AR applications in gaming, retail, education, healthcare, and more."
        ],
        gallery: [
            images.session7Gallery1,
            images.session7Gallery2
        ],
        agenda: [
            "Introduction to AI and AR",
            "AI-Driven AR Experiences",
            "Machine Learning in Augmented Reality",
            "AI-Powered AR in Industries",
            "Future of AI and AR Integration"
        ],
        learningOutcomes: [
            "Understand the role of AI in enhancing AR experiences.",
            "Learn about AI-driven AR applications across industries.",
            "Discover machine learning techniques used in AR.",
            "Explore real-world use cases of AI-powered AR.",
            "Gain insights into the future of AI and AR innovation."
        ],
        speakerIds: [1, 2],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 8,
        image: images.session8,
        title: "The Role of AI in Financial Markets",
        content: "Dive into how AI is reshaping the financial markets, from algorithmic trading to risk management.",
        details: {
            category: "Technology, AI, Finance",
            date: "2 January 2025",
            time: "5:45 PM - 7:00 PM",
            venue: "Tech Lab",
            organizer: "AI & Finance Summit",
            number: "+123-456-7897",
            email: "info@aifinance.com",
            entryFee: "$120 per attendee"
        },
        paragraphs: [
            "Discover how AI is transforming financial markets with advanced analytics, predictive modeling, and real-time decision-making.",
            "Gain insights into the impact of AI on trading strategies, fraud detection, risk assessment, and the future of financial technology."
        ],
        gallery: [
            images.session8Gallery1,
            images.session8Gallery2
        ],
        agenda: [
            "Introduction to AI in Finance",
            "Algorithmic Trading and AI",
            "Predictive Analytics in Financial Markets",
            "AI-Driven Risk Management",
            "Future Trends in AI and Finance"
        ],
        learningOutcomes: [
            "Understand how AI enhances financial decision-making.",
            "Explore AI applications in trading and investment.",
            "Learn about AI-driven fraud detection techniques.",
            "Discover how AI improves risk management strategies.",
            "Gain insights into the future of AI in fintech."
        ],
        speakerIds: [8, 7],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },

    {
        id: 9,
        image: images.session9,
        title: "AI in Agriculture: Smart Farming Solutions",
        content: "Learn about AI applications in agriculture and how they are optimizing farming practices and enhancing crop yield.",
        details: {
            category: "Technology, AI, Agriculture",
            date: "3 January 2025",
            time: "10:45 AM - 12:15 PM",
            venue: "Innovation Hall",
            organizer: "AgriTech AI Forum",
            number: "+123-456-7898",
            email: "info@aitech.com",
            entryFee: "$90 per attendee"
        },
        paragraphs: [
            "Discover how AI is revolutionizing agriculture by improving efficiency, reducing waste, and increasing productivity.",
            "Learn about AI-driven predictive analytics, precision farming, and smart irrigation techniques that are transforming modern agriculture."
        ],
        gallery: [
            images.session9Gallery1,
            images.session9Gallery2
        ],
        agenda: [
            "Introduction to AI in Agriculture",
            "Precision Farming with AI",
            "AI-Based Crop Monitoring and Pest Control",
            "Smart Irrigation and Water Management",
            "Future Trends in AI-Driven Farming"
        ],
        learningOutcomes: [
            "Understand AI-driven precision farming techniques.",
            "Learn how AI optimizes crop monitoring and pest control.",
            "Explore smart irrigation and water management solutions.",
            "Discover AI applications in soil analysis and yield prediction.",
            "Gain insights into the future of AI in sustainable agriculture."
        ],
        speakerIds: [2, 5],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 10,
        image: images.session10,
        title: "AI in LegalTech: Transforming Law Practices",
        content: "Discover how AI is revolutionizing the legal industry by enhancing legal research, case analysis, and client services.",
        details: {
            category: "Technology, AI, LegalTech",
            date: "3 January 2025",
            time: "12:30 PM - 2:00 PM",
            venue: "Tech Lab",
            organizer: "LegalTech AI Forum",
            number: "+123-456-7899",
            email: "info@legaltechai.com",
            entryFee: "$100 per attendee"
        },
        paragraphs: [
            "Explore how AI-powered tools are transforming legal research, document automation, and contract analysis.",
            "Learn about AI's impact on litigation, case prediction, and client interaction, enhancing efficiency in legal services."
        ],
        gallery: [
            images.session10Gallery1,
            images.session10Gallery2
        ],
        agenda: [
            "Introduction to AI in LegalTech",
            "AI-Powered Legal Research and Case Analysis",
            "Automating Contracts and Document Review",
            "Ethical and Regulatory Challenges in AI-Driven Law",
            "Future Trends in AI for Legal Services"
        ],
        learningOutcomes: [
            "Understand AI applications in legal research and case analysis.",
            "Discover AI-driven automation in contracts and document review.",
            "Learn about predictive analytics in legal decision-making.",
            "Explore ethical and regulatory challenges in AI-powered law.",
            "Gain insights into the future of AI in legal services."
        ],
        speakerIds: [7, 8],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 11,
        image: images.session11,
        title: "AI and Diversity: Bias in Algorithms",
        content: "Dive into the challenges of bias in AI algorithms and discuss strategies for promoting fairness and diversity in AI systems.",
        details: {
            category: "Technology, AI, Ethics, Diversity",
            date: "3 January 2025",
            time: "2:15 PM - 3:45 PM",
            venue: "Hall No 2",
            organizer: "AI Ethics and Fairness Forum",
            number: "+123-456-7800",
            email: "info@aifairness.com",
            entryFee: "$100 per attendee"
        },
        paragraphs: [
            "Explore the ethical challenges of AI, focusing on biases in algorithms and their impact on decision-making.",
            "Learn about strategies and methodologies for reducing bias and ensuring AI systems promote diversity and fairness."
        ],
        gallery: [
            images.session11Gallery1,
            images.session11Gallery2
        ],
        agenda: [
            "Introduction to Bias in AI Algorithms",
            "Case Studies: Real-World Impact of Algorithmic Bias",
            "Techniques for Detecting and Mitigating Bias",
            "Ethical AI: Principles for Fair and Inclusive Systems",
            "Future of AI Fairness and Policy Recommendations"
        ],
        learningOutcomes: [
            "Understand how bias affects AI decision-making.",
            "Discover real-world cases of AI bias and its consequences.",
            "Learn techniques for identifying and mitigating algorithmic bias.",
            "Explore ethical AI principles for fairness and diversity.",
            "Gain insights into future trends in AI fairness and regulation."
        ],
        speakerIds: [5, 2],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    },
    {
        id: 12,
        image: images.session12,
        title: "AI in Smart Cities: Urban Development",
        content: "Understand how AI is shaping the development of smart cities and enhancing urban living through innovative solutions.",
        details: {
            category: "Technology, AI, Smart Cities, Urban Development",
            date: "3 January 2025",
            time: "4:00 PM - 5:30 PM",
            venue: "Main Auditorium",
            organizer: "Smart Cities Innovation Forum",
            number: "+123-456-7891",
            email: "info@smartcitiesai.com",
            entryFee: "$100 per attendee"
        },
        paragraphs: [
            "Explore how AI is revolutionizing urban development, from traffic management and energy efficiency to public safety and sustainability.",
            "Gain insights from industry experts on how AI-driven smart city solutions are improving quality of life and shaping the future of urban environments."
        ],
        gallery: [
            images.session12Gallery1,
            images.session12Gallery2
        ],
        agenda: [
            "Introduction to AI in Smart Cities",
            "AI-Powered Traffic and Transportation Management",
            "Energy Efficiency and Sustainable Infrastructure",
            "Public Safety and AI-Driven Security Systems",
            "The Future of AI in Urban Planning and Governance"
        ],
        learningOutcomes: [
            "Understand the role of AI in urban development and city planning.",
            "Explore AI applications in traffic, energy, and sustainability.",
            "Learn how AI enhances public safety and security in smart cities.",
            "Discover real-world case studies of AI-powered urban solutions.",
            "Gain insights into future trends and policies for AI in smart cities."
        ],
        speakerIds: [4, 5],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d924234.6303368191!2d66.59494515823903!3d25.193389461148573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e06651d4bbf%3A0x9cf92f44555a0c23!2sKarachi%2C%20Karachi%20City%2C%20Sindh%2C%20Pakistan!5e0!3m2!1sen!2s!4v1645287442276!5m2!1sen!2s"
    }

]

export default schedule;